import React, { PureComponent } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

import styles from './index.css';

import Chip from 'Chip';

/**
 * 区域盛典
 */
class RankingNav extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        onChange: PropTypes.func,
        cur: PropTypes.string,
    };

    render() {
        const { content, cur, onChange } = this.props;

        // console.log(content);

        return (
            <div className={styles.areas}>
                {content.map(item => (
                    <div key={item.title} className={styles.areaItem} onClick={() => onChange(item.title)}>
                        <img src={cur === item.title ? item.icon_active : item.icon} alt="" />
                        <div className={cur === item.title ? styles.title_active : styles.title}>{item.title}</div>
                        <div className={styles.date}>{item.date}</div>
                    </div>
                ))}
            </div>
        );
    }
}

const RankingNavChip = props => (
    <Chip id="230213" type="struct" title="美食盛典-美食榜单-区域tab" groupName="正文-美食榜单" content={props.content}>
        <RankingNav onChange={props.onChange} cur={props.cur} />
    </Chip>
);

RankingNavChip.propTypes = {
    content: PropTypes.array,
    onChange: PropTypes.func,
    cur: PropTypes.string,
};

export default errorBoundary(RankingNavChip);
